var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPendoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 6.071 11.071 11.071"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF4876",
  fillRule: "evenodd",
  d: "M0 11.574h5.555v5.433l5.556-5.433V6.141H5.555z",
  clipRule: "evenodd"
})));
export { SvgPendoIcon as ReactComponent };
export default __webpack_public_path__ + "dcfaeccbfd38fd66be8d9e8dfbce9db2.svg";